var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-col",
    [
      _c("el-row", { staticClass: "tree-head" }, [
        _c("span", { staticStyle: { float: "left", "padding-left": "10px" } }, [
          _vm._v(_vm._s(_vm.$t("panel.all_org"))),
        ]),
      ]),
      _c(
        "el-row",
        { staticStyle: { "margin-top": "5px" } },
        [
          _c("el-tree", {
            ref: "tree",
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.treeData,
              lazy: "",
              load: _vm.loadTree,
              props: _vm.defaultProps,
              "default-expanded-keys": _vm.expandNodeIds,
              "node-key": "deptId",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var node = ref.node
                  var data = ref.data
                  return _c("span", { staticClass: "custom-tree-node" }, [
                    _c("span", [
                      _c("span", { staticStyle: { "margin-left": "6px" } }, [
                        _vm._v(_vm._s(node.data.name)),
                      ]),
                    ]),
                    _c(
                      "span",
                      {
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                          },
                        },
                      },
                      [
                        _c("div", [
                          _c(
                            "span",
                            { staticClass: "auth-span" },
                            [
                              _c("el-checkbox", {
                                on: {
                                  change: function ($event) {
                                    return _vm.nodeStatusChange(data)
                                  },
                                },
                                model: {
                                  value: data.checked,
                                  callback: function ($$v) {
                                    _vm.$set(data, "checked", $$v)
                                  },
                                  expression: "data.checked",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ])
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }